export default __webpack_public_path__ + "static/media/logo-google-playstore.3eb49317.svg";